import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'
import {findChildren, setStore} from "../../../../utils/Utils";

class EazyReportDirectoryStore {

    //Constructor***************************************************************************************************** */

    @observable list
    @observable page
    @observable tree
    @observable modal
    @observable editFields
    @observable info
    @observable option
    @observable brands
    @observable carSeries
    @observable modalSelect
    @observable brandId
    @observable carSeriesId
    @observable uploadCarseriesId
    @observable loading
    @observable modalFirst
    @observable pagination
    @observable copyCatalogModel //目录复制model
    @observable copyCarModel //车系复制model
    @observable leftSelectCarId//左边选中车系id
    @observable rightSelectCarId //右边车系选中id
    @observable leftSelectCatalogId//左边选中目录id
    @observable rightSelectCatalogId //右边选中目录id
    @observable leftList //左边目录集合
    @observable rightList//右边目录集合
    @observable carList //初始化车系车系集合
    @observable leftSelectLevel//左边目录树选中层级
    @observable rightSelectLevel //右边选中层级
    @observable dragList
    @observable rowData
    @observable expandedLeftRowKeys
    @observable dragState //是否显示拖拽后保存按钮
    @observable carseriesId // 点击查看目录需要的参数id
    @observable carseriesName //点击查看目录需要的参数名字

    constructor () {
        this.modalFirst = 'hide'
        this.modal = 'hide'
        this.modalSelect = 'hide'
        this.list = []
        this.page = {
            current: 0,
            total: 1
        }
        this.info = []
        this.option = []
        this.tree = []
        this.editFields = {}
        this.pagination = {}
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.brandId = []
        this.carSeriesId = []
        this.uploadCarseriesId = []
        this.loading = false
        this.copyCatalogModel = false
        this.copyCarModel = false
        this.leftList = []
        this.rightList = []
        this.leftSelectCarId = ''
        this.leftSelectCatalogId = ''
        this.rightSelectCarId = ''
        this.rightSelectCatalogId = ''
        this.carList = []
        this.leftSelectLevel = ''
        this.rightSelectLevel = ''
        this.dragList = []
        this.rowData = {}
        this.expandedLeftRowKeys = []
        this.dragState = false
    }


    //List.js.js.js************************************************************************************************************ */

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    //Page
    @action
    initListPage = async (page,value) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        let search = value || ''
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/list`, {
            page: page,
            carseriesName: search
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content.map(l => {
                return {
                    id: l.id,
                    brandName: l.brandName,
                    carseriesName: l.carseriesName,
                    state: l.state,
                    brandId: l.brandId,
                    carseriesImage: l.carseriesImage,
                    carseriesId: l.carseriesId
                }
            })
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /***
     * 删除
     * @param rocord
     * @returns {Promise<void>}
     */
    @action
    deleteByCarseriesId = async (rocord) => {
        const res = await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService//jsjb/carseriesCatalog/delete?id=` + rocord.id + '&&carseriesId=' + rocord.carseriesId)
        if (res && res.status === 0) {
            return
        }
        if(res.status){
            message.success('删除成功')
        }
        this.initListPage(this.page)
    }

    /**
     * 复制功能开始
     */
    @action
    initCarseriesList = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog`)
        if (res && res.status === 0) {
            message.error('请求车系失败！');
            return
        }
        runInAction(() => {
            res.then((c) => {
                this.carList = c
            })
            this.loading = false
        })
    }

    @action
    isShowCopyCatalogModel = () => {
        this.copyCatalogModel = true
    }
    @action
    isShowCarCopyModel = () => {
        this.copyCarModel = true
    }

    @action
    bindLeftSelectCarId = async (carId) => {
        this.leftSelectCarId = carId
        if (carId === undefined) {
            this.leftList = []
            this.leftSelectCatalogId = ''
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${carId}`)
        runInAction(() => {
            if(res.length===0){
                this.leftSelectCarId=''
                message.warning(`该车系无目录，请重新选择车系！`)
            }
        })
    }
    @action
    bindRightSelectCarId = async (carId) => {
        this.rightSelectCarId = carId
        this.rightSelectCatalogId = ''
        if (carId === undefined) {
            this.rightList = []
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${carId}`)
        runInAction(() => {
            if(res.length>0){
                this.rightSelectCarId = ''
                message.warning(`该车系已存在目录，请重新选择车系！`)
            }
            let data = this.carList.find(item=>item.carseriesId===carId)
            if(data&&data.copyStatus===1){
                this.rightSelectCarId = ''
                message.warning(`车系正在复制中!`)
            }
        })
    }
    @action
    copyCarModelClose = () => {
        this.copyCarModel = false
        this.leftSelectCarId=''
        this.rightSelectCarId=''
    }
    @action
    submitCopyCar = async () => {
        runInAction(() => {
            this.loading = true
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/copyStatus/${this.rightSelectCarId}`)
        await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/copy/null/${this.leftSelectCarId}/${this.rightSelectCarId}/null`)
        runInAction(() => {
            this.copyCarModelClose()
            this.initListPage()
            message.warning(`车系正在复制中，请勿操作！`)
            this.loading = false
        })

    }

    @action
    closeCopyModel = () => {
        this.copyCatalogModel = false
        this.leftSelectCarId = ''
        this.leftSelectCatalogId = ''
        this.rightSelectCarId = ''
        this.rightSelectCatalogId = ''
        this.rightList = []
        this.leftList = []
        this.leftSelectLevel=''
        this.rightSelectLevel=''
    }

    /**
     * 左边树目录
     */
    @action
    leftSelectTree = async (carId) => {
        runInAction(() => {
            this.loading = true
            this.leftSelectCarId = carId
        })
        if (carId === undefined) {
            this.leftList = []
            this.leftSelectCatalogId = ''
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${carId}`)
        runInAction(() => {
            this.leftList = res.length ? res : []
            this.loading = false
        })
    }
    /**
     * 右边树目录
     * @param carId
     * @returns {Promise<void>}
     */
    @action
    rightSelectTree = async (carId) => {
        runInAction(() => {
            this.loading = true
            this.rightSelectCarId = carId
            this.rightSelectCatalogId = ''
        })
        if (carId === undefined) {
            this.rightList = []
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${carId}`)
        runInAction(() => {
            this.rightList = res.length ? res : []
            let data = this.carList.find(item=>item.carseriesId===carId)
            if(data&&data.copyStatus===1){
                this.rightSelectCarId = ''
                message.warning(`车系正在复制中!`)
            }
            this.loading = false
        })
    }

    /**
     * 目录复制提交
     * @returns {Promise<void>}
     */
    @action
    copyCatalogSubmit = async () => {
        if(this.leftSelectCarId!== ''&&this.rightSelectCarId!==''&&this.leftSelectCatalogId!==''){
            if(this.rightSelectLevel===this.leftSelectLevel-1||(this.leftSelectLevel===1&&!this.rightSelectLevel)){
                this.loading = true
                const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/copy/${this.leftSelectCatalogId}/${this.leftSelectCarId}/${this.rightSelectCarId}/${this.rightSelectCatalogId.length>0?this.rightSelectCatalogId:null}`)
                runInAction(() => {
                    if (res && res.status >= 400) {
                        message.error('目录复制失败')
                        return
                    }
                    message.success('目录复制成功！');
                    this.closeCopyModel()
                    this.loading = false
                })
            }else {
                message.error('选择新老车系目录层级不正确，请检查')
            }
        }else {
            message.warning('请选择新老车系目录！')
        }
    }
    @action
    bindLeftCatalog = (catalog,level) => {
        this.leftSelectCatalogId = catalog
        if(catalog.length===0){
            this.leftSelectLevel=''
        }else {
            this.leftSelectLevel=level
        }
    }
    @action
    bindRightCatalog = (catalog,level) => {
        this.rightSelectCatalogId = catalog
        if(catalog.length===0){
            this.rightSelectLevel=''
        }else {
            this.rightSelectLevel=level
        }
    }

    //Selects************************************************************************************************************ */

    //Brand List.js.js.js
    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.carSeries = {
                list: [],
                selected: ''
            }
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand:brandList`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands.list = res
            this.loading = false
            this.modalSelect = 'show'
        })
    }

    //Carseries List.js.js.js
    @action
    initCarseries = async (id) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/list/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = res
        })
    }

    //Save BrandId
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    //Save CarSeriesId
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    //Save Catalog
    @action
    saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        //If NUll
        if (this.brandId.length === 0 || this.carSeriesId.length === 0) {
            message.warning('请选择品牌和车系')
            return
        }
        //Get Brand Info
        let brand = []
        const brandList = this.brands.list
        for (let i = 0; i < brandList.length; i++) {
            if (brandList[i].id === this.brandId) {
                brand = brandList[i]
            }
        }
        //Get carSeries Info
        let carSeries = []
        const carSeriesList = this.carSeries.list
        for (let i = 0; i < carSeriesList.length; i++) {
            if (carSeriesList[i].id === this.carSeriesId) {
                carSeries = carSeriesList[i]
            }
        }
        //Save
        const data = {
            'carseriesName': carSeries.defaultName,
            'carseriesImage': carSeries.icon,
            'carseriesId': carSeries.id,
            'rank': carSeries.rank,
            'isDelete': 0,
            'brandName': brand.defaultName,
            'brandId': brand.id,
            'state': 0
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/add`, data)
        runInAction(() => {
            if(res.status===1){
                if(res.data==='新增成功'){
                    message.success(res.data)
                }else {
                    message.warning(res.data)
                }
            }
            this.loading = false
            this.modalSelect = 'hide'
        })
        this.initListPage(this.page)
    }

    //Edit************************************************************************************************************ */

    //ClearTree
    @action.bound
    clearEditPage () {
        runInAction(() => {
            this.modal = 'hide'
        })
        this.tree = []
    }

    //Tree
    @action
    initEditPage = async (carseriesId) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${carseriesId}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.tree = Array.isArray(res)?findChildren(res):[]
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.dragList=Array.isArray(res)?initList:[]
            this.uploadCarseriesId = carseriesId
        })
    }

    //Delete CatalogId
    @action
    deleteOne = async (record) => {
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/delete?id=${record.id}`)
        message.success('删除成功')
        this.initEditPage(record.carseriesId)
    }

    //Box************************************************************************************************************* */

    //ShowBox
    @action
    showBox = (record, option) => {
        if(option === 'update'){
            runInAction(()=>{
                this.editFields.content = record.defaultName
            })
        }else{
            runInAction(()=>{
                this.editFields.content = ''
            })
        }
        runInAction(() => {
            this.loading = true
            this.info = record
            this.option = option
            this.modal = 'show'
            this.loading = false
        })
    }

    @action
    showFirstBox = () => {
        runInAction(() => {
            this.loading = true
            this.editFields.content = ''
            this.modalFirst = 'show'
            this.loading = false
        })
    }

    @action
    insertNew = async (content, info, option) => {
        //SaveLv1
        const data = {
            'carseriesId': this.uploadCarseriesId,
            'defaultName': content.content,
            'id': null,
            'level': 1,
            'pId': '',
            'sort': info.sort
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/insertNew`, data)
        runInAction(() => {
            this.modalFirst = 'hide'
        })
        this.initEditPage(data.carseriesId)
        return

    }

    @computed get fields () {
        let fields = {
            content: {value: this.editFields.content},
        }
        return fields
    }

    //Cast
    @action.bound
    onEditFieldChange (changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            content: fields.content.value,
        }
        this.editFields = editFields
    }

    //SaveLv1||SaveSame||SaveChild||Update
    @action
    operation = async (content, info, option) => {
        //SaveLv1
        if (info.length === 0 && option.length === 0 ) {
            const data = {
                'carseriesId': this.uploadCarseriesId,
                'defaultName': content.content,
                'id': null,
                'level': 1,
                'pId': '',
                'sort': info.sort
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/insertSame`, data)
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${this.uploadCarseriesId}`)
            runInAction(() => {
                this.modal = 'hide'
                let initList=[]
                res.map(item=>{
                    initList.push({...item,children:''})
                })
                this.rowData.id?this.clickRow(this.rowData):this.dragList=Array.isArray(res)?initList:[]
            })
            this.initEditPage(data.carseriesId)
            return
        }
        //SaveSame||SaveChild||Update
        let data = {
            'carseriesId': info.carseriesId,
            'defaultName': content.content,
            'id': info.id,
            'level': info.level,
            'pId': info.pId,
            'sort': info.sort
        }
        if (option === 'addSame') {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/insertSame`, data)
        } else if (option === 'addChild') {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/insertChild`, data)
        } else if (option === 'update') {
            const updateData = {
                'defaultName': content.content,
                'id': info.id,
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/update`, updateData)
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${this.uploadCarseriesId}`)
        runInAction(() => {
            this.modal = 'hide'
            this.tree = Array.isArray(res)?findChildren(res):[]
            let initList=[]
            res.map(item=>{
                initList.push({...item,children:''})
            })
            this.rowData.id?this.clickRow(this.rowData):this.dragList=Array.isArray(res)?initList:[]
        })
        this.initEditPage(data.carseriesId)
    }

    /**
     *取消编辑
     */
    @action.bound
    cancelEdit () {
        this.loading = false
        this.modalSelect = 'hide'
    }

    //HideBox
    @action
    closeBox = () => {
        this.modal = 'hide'
    }

    @action
    closeFirstBox = () => {
        this.modalFirst = 'hide'
    }

    //Show Add Lv1 Catalog Box
    @action
    showAddFirstBox = () => {
        runInAction(() => {
            this.loading = true
            this.editFields.content = ''
            this.modal = 'show'
            this.loading = false
        })
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId= async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        let state = rocord.state? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            return
        }
        if(state === 1){
            message.success('发布成功！');
        }else{
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.initListPage(this.page)
    }

    /****
     * 点击行数据
     */
    @action
    clickRow=async (record)=>{
        this.rowData=record
    }
    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys=(expandedRows)=>{
        this.expandedLeftRowKeys = expandedRows
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort=async ()=>{
        let dragList = []
        this.dragList.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/modifySort`,dragList)
        if (res && res.status === 0) {
            return
        }
        runInAction(()=>{
            this.dragState=false
        })
        await this.initEditPage(this.uploadCarseriesId)
    }

    //End************************************************************************************************************* */
}
export default new EazyReportDirectoryStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/Briefing/BriefingDirectory/store.js